import { AppPermission, CurrentUser } from '@sdir/auth/lib/types';

interface IAppPermissions {
  CreateApplication: AppPermission;
}

const serviceIdentifier = 'app-mss-aps';

// All AppPermissions must have the same service identifier
export const AppPermissions: IAppPermissions = {
  CreateApplication: {
    name: `${serviceIdentifier}.Applications.Create`,
    description: 'Access to creating an application in the MSS client.',
  },
};

export const OrganizationRole = 'idporten.samferdsel';
export const OrganizationCourseRole = 'idporten.sfd-kurs';
export const OrganizationDispensationRole = 'idporten.sfd-skip';
export const OrganizationEndorsementRole = 'idporten.sfd-pategning';
export const OrganizationSeagoingRole = 'idporten.sfd-fartstid';
export const OrganizationPaymentRole = 'idporten.sfd-betaling';

export const ExtOrganizationRole = 'externaluser.organizationrepresentative';
export const PersonRole = 'idporten.person';
export const ExternalUserRole = 'externaluser.user';

export const ToggleCertificates = 'MSS_HideCertificates';
export const ToggleEndorsement = 'MSS_HideEndorsement';
export const ToggleApplications = 'MSS_HideApplications';
export const ToggleHealth = 'MSS_HideHealth';
export const ToggleProfile = 'MSS_HideProfile';
export const ToggleAssessment = 'MSS_HideAssessment';
export const TogglePaymentOverview = 'MSS_HidePaymentOverview';
export const ToggleRequirementList = 'MSS_HideRequirementList';
export const ToggleShareCompetence = 'MSS_HideShareCompetence';
export const ToggleDisablePrinting = 'MSS_DisablePrinting';
export const ToggleDisableLanguage = 'MSS_DisableLanguage';
export const ToggleHideLetter = 'MSS_HideTextForNoLetter';
export const ToggleAvailableCertificates = 'MSS_AvailableCertificates';
export const ToggleDisableNewSeagoing = 'MSS_DisableNewSeagoingRegistration';
export const ToggleDisableExternalUsers = 'APS_DisableExternalUsers';
export const ToggleDisableSid = 'MSS_HideSid';
export const ToggleDisableEducatia = 'MSS_HideEducatia';

export const isToggleOn = (featureToggles, toggle, user) => {
  if (!featureToggles) return false;
  const foundToggle = featureToggles?.find((f) => f.name === toggle);
  const variant = foundToggle?.variant;
  if (variant?.name === 'users' && variant?.payload?.value) {
    const value = JSON.parse(variant.payload.value);
    return !value?.includes(user);
  }
  return !!foundToggle;
};

export const getAvailableCertificates = (featureToggles, toggle, user) => {
  if (!featureToggles) return { certificateCodes: [], userOverride: false };
  const foundToggle = featureToggles?.find((f) => f.name === toggle);
  const variant = foundToggle?.variant;
  let certificateCodes: string[] = [];
  let userOverride = false;
  if (variant?.name === 'settings' && variant?.payload?.value) {
    const settings = JSON.parse(variant.payload.value);
    certificateCodes = settings?.certificateCodes || [];
    userOverride = !!settings?.users?.includes(user);
  }
  return { certificateCodes, userOverride };
};

export const checkIsOrganization = (currentUser?: CurrentUser) => {
  const userRoles = currentUser?.profile?.role || [];
  if (userRoles.indexOf(OrganizationRole) !== -1) return true;
  if (userRoles.indexOf(OrganizationCourseRole) !== -1) return true;
  if (userRoles.indexOf(OrganizationDispensationRole) !== -1) return true;
  if (userRoles.indexOf(OrganizationEndorsementRole) !== -1) return true;
  if (userRoles.indexOf(OrganizationSeagoingRole) !== -1) return true;
  if (userRoles.indexOf(OrganizationPaymentRole) !== -1) return true;
  if (userRoles.indexOf(ExtOrganizationRole) !== -1) return true;
  return false;
};
